import { PATIENT_ACCOUNT, PATIENT_CSRF_TOKEN, PATIENT_EXPIRES } from "constants/StorageConstants"

import { getCurrentPatientStorage } from "./currentPatientStorage"

/**
 *  Clear the patient authentication state from the storage. This should be
 *  used after the user logs out.
 */
export const patientClearAuth = () => {
  // clear the current patient storage
  getCurrentPatientStorage().clear()

  // remove the obsolete storage items
  localStorage.removeItem(PATIENT_CSRF_TOKEN)
  localStorage.removeItem(PATIENT_ACCOUNT)
  localStorage.removeItem(PATIENT_EXPIRES)
}

/**
 * Data wrapper
 */
export const publicAxiosHooks = {
  practiceSlug: "",
  careGroupSlug: "",
  patientLogoutAutomatic: patientClearAuth,
}
